import {
  Gauge,
  Inbox,
  MessagesSquare,
  BookOpen,
  LayoutList,
  Hammer,
  Bolt,
  Rocket,
} from "lucide-react";
import type { NavGroup } from "./nav-main";
import { ChatNavItem } from "./ChatNavItem";
import { UpdateAvailableNavItem } from "./UpdateAvailableNavItem";
import { routes } from "@/lib/routes";
import { recallPath } from "@/lib/last-path";

export const operatorNavGroups: NavGroup[] = [
  {
    items: [
      { title: "Overview", href: routes.operator.overview, icon: Gauge, end: true },
      { title: "Inbox", href: routes.operator.inbox, icon: Inbox },
      { title: "Activity", href: routes.operator.activity, icon: LayoutList },
      { title: "Knowledge", href: routes.operator.knowledge, icon: BookOpen },
      { title: "Builder", href: routes.operator.builder, icon: Hammer },
      {
        title: "Chat",
        href: routes.operator.chats,
        icon: MessagesSquare,
        render: (collapsed) => <ChatNavItem collapsed={collapsed} />,
      },
    ],
  },
  {
    items: [
      // Sits above the Console cross-link, hidden unless CloudFront reports
      // a build different from the one this tab booted with — see
      // `src/lib/version-monitor.ts`. Mirrors the placement in
      // `console-nav.tsx` so the prompt appears in the same spot on both
      // surfaces.
      {
        title: "Update available",
        href: "#",
        icon: Rocket,
        render: (collapsed) => <UpdateAvailableNavItem collapsed={collapsed} />,
      },
      {
        title: "Console",
        href: () => recallPath("console", routes.console.root),
        icon: Bolt,
      },
    ],
  },
];
